//import * as React from "react";
import React, { useRef, useEffect, useState } from "react";

import Barra from "./Barra"


//{ "pza":12, id_prod :0, color:"white", partes:  "00000", interno: false},
//{pza: 11, id_prod: 0, color: 'white', partes: '00000', interno: false}
//------parametros inicializados

const RenderBarras2 = ({ data=[] }) => {
  //"#fff"
  //let color= props.color || '#fff';
  console.log('data');
  console.log(data);
   
  return (
    <span>
    { data.map((item,index) =>(
      <div key={index}>

        {item.pieza=== 18 &&
        <Barra pieza={18}  backColor={item.colorb2} width={60} height={11} style={{top: '278', left: '39',transform: 'rotate(95deg)' }} className="abs" />
        }
        {item.pieza=== 17 &&
        <Barra pieza={17}  backColor={item.colorb2} width={60} height={11} style={{top: '235', left: '44',transform: 'rotate(95deg)' }} className="abs" />
        }
        {item.pieza=== 16 &&
        <Barra pieza={16}  backColor={item.colorb2} width={60} height={11} style={{top: '189', left: '49',transform: 'rotate(96deg)' }} className="abs" />
        }
        {item.pieza=== 15 &&
        <Barra pieza={15}  backColor={item.colorb2} width={65} height={11} style={{top: '145', left: '55',transform: 'rotate(96deg)' }} className="abs" />
        }
        {item.pieza=== 14 &&
        <Barra pieza={14}  backColor={item.colorb2} width={60} height={11} style={{top: '107', left: '64',transform: 'rotate(100deg)' }} className="abs" />
        }
        {item.pieza=== 13 &&
        <Barra pieza={13}  backColor={item.colorb2} width={55} height={11} style={{top: '74', left: '84',transform: 'rotate(125deg)' }} className="abs" />
        }
        {item.pieza=== 12 &&
        <Barra pieza={12}  backColor={item.colorb2} width={45} height={11} style={{top: '58', left: '115',transform: 'rotate(160deg)' }} className="abs" />
        }
        {item.pieza=== 11 &&
        <Barra pieza={11}  backColor={item.colorb2} width={35} height={11} style={{top: '54', left: '145',transform: 'rotate(180deg)' }} className="abs" />
        }
        {/**-------------------------------------------------------------------------------------- */}
        {item.pieza=== 21 &&
        <Barra pieza={21}  backColor={item.colorb2} width={35} height={11} style={{top: '54', left: '170',transform: 'rotate(180deg)' }} className="abs" />
        }
        {item.pieza=== 22 &&
        <Barra pieza={22}  backColor={item.colorb2} width={45} height={11} style={{top: '67', left: '199',transform: 'rotate(205deg)' }} className="abs" />
        }
        {item.pieza=== 23 &&
        <Barra pieza={23}  backColor={item.colorb2} width={50} height={11} style={{top: '92', left: '219',transform: 'rotate(240deg)' }} className="abs" />
        }
        {item.pieza=== 24 &&
        <Barra pieza={24}  backColor={item.colorb2} width={60} height={11} style={{top: '135', left: '224',transform: 'rotate(257deg)' }} className="abs" />
        }
        {item.pieza=== 25 &&
        <Barra pieza={25}  backColor={item.colorb2} width={60} height={11} style={{top: '173', left: '232',transform: 'rotate(260deg)' }} className="abs" />
        }
        {item.pieza=== 26 &&
        <Barra pieza={26}  backColor={item.colorb2} width={60} height={11} style={{top: '214', left: '239',transform: 'rotate(263deg)' }} className="abs" />
        }
        {item.pieza=== 27 &&
        <Barra pieza={27}  backColor={item.colorb2} width={60} height={11} style={{top: '260', left: '246',transform: 'rotate(263deg)' }} className="abs" />
        }
        {item.pieza=== 28 &&
        <Barra pieza={28}  backColor={item.colorb2} width={60} height={11} style={{top: '302', left: '251',transform: 'rotate(263deg)' }} className="abs" />
        }
        {/**--------------------- parte de abajo------------------------------------------ */}
        {item.pieza=== 48 &&
        <Barra pieza={48}  backColor={item.colorb2} width={60} height={11} style={{top: '79', left: '350',transform: 'rotate(85deg)' }} className="abs" />
        }
        {item.pieza=== 47 &&
        <Barra pieza={47}  backColor={item.colorb2} width={60} height={11} style={{top: '126', left: '355',transform: 'rotate(84deg)' }} className="abs" />
        }
        {item.pieza=== 46 &&
        <Barra pieza={46}  backColor={item.colorb2} width={60} height={11} style={{top: '175', left: '361',transform: 'rotate(80deg)' }} className="abs" />
        }
        {item.pieza=== 45 &&
        <Barra pieza={45}  backColor={item.colorb2} width={50} height={11} style={{top: '220', left: '377',transform: 'rotate(76deg)' }} className="abs" />
        }
        {item.pieza=== 44 &&
        <Barra pieza={44}  backColor={item.colorb2} width={50} height={11} style={{top: '259', left: '388',transform: 'rotate(73deg)' }} className="abs" />
        }
        {item.pieza=== 43 &&
        <Barra pieza={43}  backColor={item.colorb2} width={45} height={11} style={{top: '298', left: '404',transform: 'rotate(55deg)' }} className="abs" />
        }
        {item.pieza=== 42 &&
        <Barra pieza={42}  backColor={item.colorb2} width={35} height={11} style={{top: '319', left: '433',transform: 'rotate(15deg)' }} className="abs" />
        }
        {item.pieza=== 41 &&
        <Barra pieza={41}  backColor={item.colorb2} width={25} height={11} style={{top: '325', left: '463',transform: 'rotate(0deg)' }} className="abs" />
        }

        {item.pieza=== 31 &&
        <Barra pieza={31}  backColor={item.colorb2} width={25} height={11} style={{top: '325', left: '483',transform: 'rotate(0deg)' }} className="abs" />
        }
        {item.pieza=== 32 &&
        <Barra pieza={32}  backColor={item.colorb2} width={30} height={11} style={{top: '323', left: '501',transform: 'rotate(-10deg)' }} className="abs" />
        }
        {item.pieza=== 33 &&
        <Barra pieza={33}  backColor={item.colorb2} width={45} height={11} style={{top: '310', left: '521',transform: 'rotate(-60deg)' }} className="abs" />
        }
        {item.pieza=== 34 &&
        <Barra pieza={34}  backColor={item.colorb2} width={50} height={11} style={{top: '275', left: '534',transform: 'rotate(-75deg)' }} className="abs" />
        }
        {item.pieza=== 35 &&
        <Barra pieza={35}  backColor={item.colorb2} width={50} height={11} style={{top: '235', left: '545',transform: 'rotate(-80deg)' }} className="abs" />
        }
        {item.pieza=== 36 &&
        <Barra pieza={36}  backColor={item.colorb2} width={60} height={11} style={{top: '195', left: '550',transform: 'rotate(-82deg)' }} className="abs" />
        }
        {item.pieza=== 37 &&
        <Barra pieza={37}  backColor={item.colorb2} width={60} height={11} style={{top: '150', left: '556',transform: 'rotate(-85deg)' }} className="abs" />
        }
        {item.pieza=== 38 &&
        <Barra pieza={38}  backColor={item.colorb2} width={60} height={11} style={{top: '105', left: '560',transform: 'rotate(-85deg)' }} className="abs" />
        }
      </div>
      ))}
  </span>
)};
export default RenderBarras2;